var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"acts-mode-control"},[_c('i-button',{attrs:{"icon":_vm.getIcon()},on:{"click":_vm.toggleMode}},[_vm._v("\n    "+_vm._s(_vm.getLabel())+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }